import { render, staticRenderFns } from "./China.vue?vue&type=template&id=6e4d4e80&scoped=true"
import script from "./China.vue?vue&type=script&lang=js"
export * from "./China.vue?vue&type=script&lang=js"
import style0 from "./China.vue?vue&type=style&index=0&id=6e4d4e80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d4e80",
  null
  
)

export default component.exports